import type { AtendimentoAbertoPorContato } from '@/services/atendimentos/atendimentos.service';

type Atendente = AtendimentoAbertoPorContato['atendentes'][number];

/**
 * Atendente(s) que IMPEDEM o usuário de entrar num atendimento aberto.
 *
 * Mesma regra do ContactsModal: o atendimento está com outra pessoa e o usuário
 * não tem `inbox.ver_todos_atendimentos` naquele inbox. Em espera (sem atendente)
 * ou já com o próprio usuário não bloqueia. Devolve `null` quando não há bloqueio.
 */
export function atendentesQueBloqueiam(
    aberto: Pick<AtendimentoAbertoPorContato, 'atendentes'> | null | undefined,
    idUsuario: string | null | undefined,
    podeVerTodosNoInbox: boolean,
): Atendente[] | null {
    if (!aberto?.atendentes?.length || podeVerTodosNoInbox) return null;
    if (idUsuario && aberto.atendentes.some(a => a.id == idUsuario)) return null;
    return aberto.atendentes;
}

/** "Maria", "Maria e João", "Maria, João e Ana". */
export function nomesDosAtendentes(atendentes: Pick<Atendente, 'nome'>[]): string {
    const nomes = atendentes.map(a => a.nome).filter(Boolean);
    if (nomes.length <= 1) return nomes[0] ?? 'outro atendente';
    return `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`;
}
